import { render, staticRenderFns } from "./VResetPassword.vue?vue&type=template&id=1ff8d9bd&"
import script from "./VResetPassword.vue?vue&type=script&lang=js&"
export * from "./VResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports